<template>
  <el-dialog
    :title="dialogTitle"
    :visible="true"
    width="800px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="
      () => {
        handleClose(false)
      }
    "
  >
    <el-form
      ref="form"
      :model="form"
      label-width="200px"
      :disabled="publicDisabled"
      :rules="rules"
    >
      <h3>1、单位基本信息</h3>
      <el-form-item label="联系人姓名" prop="contactsName">
        <el-input v-model="form.contactsName"></el-input>
      </el-form-item>
      <el-form-item label="联系人手机号" prop="contactsPhone">
        <el-input v-model="form.contactsPhone"></el-input>
      </el-form-item>
      <el-form-item label="单位名称" prop="unitName">
        <el-input v-model="form.unitName"></el-input>
      </el-form-item>
      <el-form-item label="联系人职务" prop="contactsPosition">
        <el-input v-model="form.contactsPosition"></el-input>
      </el-form-item>
      <el-form-item label="单位网址" prop="unitWebsite">
        <el-input v-model="form.unitWebsite"></el-input>
      </el-form-item>
      <el-form-item label="法定代表人姓名" prop="legalRepresentative">
        <el-input v-model="form.legalRepresentative"></el-input>
      </el-form-item>
      <el-form-item label="成立时间" prop="setUpTime">
        <el-date-picker
          v-model="form.setUpTime"
          type="date"
          placeholder="选择日期时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="员工总人数" prop="staffSum">
        <el-input v-model="form.staffSum" type="number"></el-input>
      </el-form-item>
      <el-form-item label="营业执照号" prop="licenseNum">
        <el-input v-model="form.licenseNum"></el-input>
      </el-form-item>
      <el-form-item label="注册资金（万元）" prop="registeredCapital">
        <el-input v-model="form.registeredCapital"></el-input>
      </el-form-item>
      <el-form-item label="实缴资金（万元）">
        <el-input v-model="form.paidInCapital"></el-input>
      </el-form-item>
      <el-form-item label="社会培训评价组织" prop="filingSituation">
        备案情况：
        <el-radio-group
          v-model="form.filingSituation"
          @change="filingSituationChange"
        >
          <el-radio label="1">未在人社局备案</el-radio>
          <el-radio label="2">已在人社局备案</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="（人社部第三方）" prop="evaluableOccupation">
        可评价职业（工种）
        <el-input
          :disabled="form.filingSituation === '1'"
          v-model="form.evaluableOccupation"
          placeholder="无"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="营业执照" prop="licenseUrl">
        <img
          class="apply-img"
          v-if="form.licenseUrl"
          :src="form.licenseUrl"
          alt="营业执照"
        />
        <Upload v-if="!publicDisabled" v-model="form.licenseUrl" />
      </el-form-item>
      <el-form-item label="法人身份证正面" prop="legalRepresentativeIdFront">
        <img
          class="apply-img"
          v-if="form.legalRepresentativeIdFront"
          :src="form.legalRepresentativeIdFront"
          alt="法人身份证正面"
        />
        <Upload
          v-if="!publicDisabled"
          v-model="form.legalRepresentativeIdFront"
        />
      </el-form-item>
      <el-form-item label="法人身份证反面" prop="legalRepresentativeIdReverse">
        <img
          class="apply-img"
          v-if="form.legalRepresentativeIdReverse"
          :src="form.legalRepresentativeIdReverse"
          alt="法人身份证反面"
        />
        <Upload
          v-if="!publicDisabled"
          v-model="form.legalRepresentativeIdReverse"
        />
      </el-form-item>
      <h3>2、主营业务信息</h3>
      <el-form-item label="培训业务经验（年）">
        <el-input v-model="form.trainingBusinessExperience"></el-input>
      </el-form-item>
      <el-form-item label="培训模式（面授/远程/综合）">
        <el-input v-model="form.trainingMode"></el-input>
      </el-form-item>
      <el-form-item label="培训主题方向">
        <el-input v-model="form.trainingTopics"></el-input>
      </el-form-item>
      <el-form-item label="累计培训人次">
        <el-input v-model="form.trainingPersonTimes" type="number"></el-input>
      </el-form-item>
      <el-form-item label="自有授课场地面积">
        <el-input v-model="form.siteArea"></el-input>
      </el-form-item>
      <el-form-item label="自有实操场所/设施">
        <el-input v-model="form.operationPlace"></el-input>
      </el-form-item>
      <el-form-item label="最优招生省城或渠道" prop="studentsChannel">
        <el-input v-model="form.studentsChannel"></el-input>
      </el-form-item>
      <el-form-item
        label="培训相关经验或介绍"
        prop="trainingExperienceIntroduce"
      >
        <el-input
          v-model="form.trainingExperienceIntroduce"
          type="textarea"
          maxlength="2000"
        ></el-input>
      </el-form-item>
      <el-form-item label="招生资源简要介绍" prop="studentsIntroduce">
        <el-input
          v-model="form.studentsIntroduce"
          type="textarea"
          maxlength="2000"
        ></el-input>
      </el-form-item>
      <el-form-item label="其他主营业务">
        <el-input
          v-model="form.otherBusiness"
          type="textarea"
          maxlength="2000"
        ></el-input>
      </el-form-item>
      <h3>3、合作意向</h3>
      <el-form-item label="合作意愿" prop="cooperateDesire">
        <el-checkbox-group
          v-model="form.cooperateDesire"
          @change="cooperateDesireChange"
        >
          <el-checkbox
            v-for="item in intendList"
            :key="item.value"
            :label="item.value"
          >
            {{ item.label }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="" prop="otherDesire">
        <el-input
          :disabled="
            !(form.cooperateDesire && form.cooperateDesire.includes('3'))
          "
          v-model="form.otherDesire"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-form
      v-if="publicDisabled"
      ref="form1"
      :model="form1"
      label-width="200px"
      :rules="rules1"
    >
      <el-form-item label="备注" prop="remarks">
        <el-input
          v-model="form1.remarks"
          type="textarea"
          maxlength="200"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="write-footer">
      <el-button class="search-but1" size="small" @click="handleClose(false)">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="handleSubmit">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import Upload from '../informationManage/module/upload.vue'
import * as API from '../../api/application/index'
import qs from 'qs'
import { intendList } from './assets'
export default {
  props: ['dialogTitle', 'handleClose', 'defaultData'],
  name: 'ApplicationForWrite',
  components: { Upload },
  data() {
    const { cooperateDesire, remarks } = this.defaultData
    return {
      intendList,
      form: {
        filingSituation: '1',
        ...this.defaultData,
        cooperateDesire: cooperateDesire?.split(',') ?? []
      },
      publicDisabled: this.dialogTitle === '合作申请详情',
      form1: {
        remarks: remarks
      },
      rules: {
        contactsName: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        contactsPhone: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        unitName: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        contactsPosition: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        unitWebsite: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        legalRepresentative: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        registeredCapital: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        licenseUrl: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        legalRepresentativeIdFront: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        legalRepresentativeIdReverse: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        studentsChannel: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        trainingExperienceIntroduce: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        studentsIntroduce: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        cooperateDesire: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        setUpTime: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        staffSum: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        licenseNum: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ],
        evaluableOccupation: [
          {
            required: false,
            message: '必填项不可为空',
            trigger: 'blur'
          }
        ],
        otherDesire: [
          { required: false, message: '必填项不可为空', trigger: 'blur' }
        ],
        filingSituation: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ]
      },
      rules1: {
        remarks: [
          { required: true, message: '必填项不可为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit() {
      const {
        form,
        form1,
        handleClose,
        publicDisabled,
        defaultData: { id }
      } = this
      if (publicDisabled) {
        this.$refs.form1.validate(async (valid) => {
          if (valid) {
            const { remarks } = form1
            const params = {
              id,
              remarks
            }
            try {
              const res = await API.addProjectCommit(params)
              const { code } = res
              if (code === 0) {
                this.$message.success('保存成功')
                handleClose('update')
              }
            } catch (error) {}
          }
        })
      } else {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            const { cooperateDesire, staffSum, trainingPersonTimes } = form
            const data = {
              ...form,
              cooperateDesire: cooperateDesire.toString(),
              staffSum: Number(staffSum),
              trainingPersonTimes: trainingPersonTimes
                ? Number(trainingPersonTimes)
                : trainingPersonTimes
            }
            try {
              const res = await API.addApplicationFor(data)
              const { code } = res
              if (code === 0) {
                this.$message.success('保存成功')
                handleClose('reset')
              }
            } catch (error) {}
          }
        })
      }
    },
    filingSituationChange(value) {
      this.$set(this.rules, 'evaluableOccupation', [
        {
          required: value === '2',
          message: '必填项不可为空',
          trigger: 'blur'
        }
      ])
    },
    cooperateDesireChange(value) {
      this.$set(this.rules, 'otherDesire', [
        {
          required: value.includes('3'),
          message: '必填项不可为空',
          trigger: 'blur'
        }
      ])
    }
  }
}
</script>
<style lang='scss' scoped>
.text-red {
  color: red;
}
.write-footer {
  text-align: right;
}
.apply-img {
  width: 280px;
  height: 170px;
}
</style>